const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case "person/SET_PERSON":
      return {
        ...state,
        [action.personUUID]: {
          ...state[action.personUUID],
          result: action.payload,
        },
      }
    case "person/SET_LOADING":
      return {
        ...state,
        [action.personUUID]: {
          ...state[action.personUUID],
          loading: action.payload,
        },
      }
    case "person/SET_ERROR":
      return {
        ...state,
        [action.personUUID]: {
          ...state[action.personUUID],
          error: action.payload,
        },
      }
    case "LOGOUT":
      return initialState
    default:
      return state
  }
}
